"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var jwt_decode_1 = require("jwt-decode");
var isTokenExpired = function (token) {
    try {
        var decoded = (0, jwt_decode_1.jwtDecode)(token);
        var currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp < currentTime;
    }
    catch (e) {
        return true; // Если токен некорректен, считать его истёкшим
    }
};
var ProtectedRoute = function (_a) {
    var component = _a.component;
    var token = (0, react_redux_1.useSelector)(function (state) { return state.authSlice.token; });
    if (!token || isTokenExpired(token)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/login" });
    }
    return component;
};
exports.default = ProtectedRoute;
